import * as React from 'react';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import { SubmitButtonProps } from 'interfaces/wizard/wizard';

const SubmitButton: React.FunctionComponent<SubmitButtonProps> = (props): React.ReactElement => {
  const { children, isSubmitting, submitText, isLoading, isSecondary } = props;
  if (typeof children === 'function') {
    return children({ ...props });
  }
  return (
    <Button
      type={isSecondary ? BUTTON_TYPES.SECONDARY : BUTTON_TYPES.PRIMARY}
      text={submitText || 'Submit'}
      isLoading={isSubmitting || isLoading}
      {...props}
    />
  );
};

export default SubmitButton;
